/**
 * Picks the "เมนูรอบนี้" backend: mock (default, like getKbApi) or `/api/v1/ai/menu-round`.
 * Separate from the knowledge state on purpose: its GET may fetch the POS catalog (slower than /ai/kb).
 */
import { useMock } from '../index'
import { HttpMenuRoundApi } from './menuHttp'
import { MockMenuRoundApi } from './menuMock'
import type { MenuRoundApi } from './menuTypes'

let current: MenuRoundApi | null = null

export function getMenuRoundApi(): MenuRoundApi {
  if (!current) {
    const base = (import.meta.env.VITE_API_BASE ?? '').trim()
    current = useMock ? new MockMenuRoundApi() : new HttpMenuRoundApi(base)
  }
  return current
}

/** Tests inject their own backend. */
export function setMenuRoundApi(api: MenuRoundApi | null): void {
  current = api
}

export type * from './menuTypes'
